import { formatDate } from 'dates';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { ContractCard as UiContractCard, Typography } from 'ui';

import { getStatusTranslation } from '~/contract/utils';
import { Annex } from '~/data/types';

interface AnnexCardProps {
  annex: Annex;
  contractNumber: string;
  customerName: string;
}

export const AnnexCard = memo(({ annex, contractNumber, customerName }: AnnexCardProps) => {
  const { t } = useTranslation('contracts');

  const { annexDate, createdDate, status, annexNumber } = annex;

  const statusText = getStatusTranslation({ status, t });

  return (
    <UiContractCard
      subtitle={t('annexSubtitle', {
        contractNumber,
      })}
      title={t('annexTitle', {
        annexNumber,
      })}
      data-testid="annex-card"
      details={[
        <Typography
          component="span"
          color={status === 'Active' || status === 'Signed' ? 'green' : 'orange.main'}
          variant="body2"
        >
          {statusText}
        </Typography>,
        <Typography component="span" variant="inherit" display="inline">
          {t('date', {
            date: formatDate({
              date: createdDate,
            }),
          })}
        </Typography>,
        annexDate && (
          <Typography component="span" variant="inherit" display="inline">
            {t('activeFromDate', {
              activeFrom: formatDate({
                date: annexDate,
              }),
            })}
          </Typography>
        ),
      ]}
      customerName={customerName}
    />
  );
});
